import { jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../types.d.ts" />
import React from 'react';
const buildConfig = window.BUILD_CONFIG || {
    PUBLIC_URL: '',
    gitInfo: {
        branch: 'unknown',
        sha: 'unknown'
    },
    UI_VERSION: '0.0.0',
    GRID_LICENSE_KEY: ''
};
console.log('UI Version:', buildConfig.UI_VERSION);
console.log('Git Info:', buildConfig.gitInfo);
console.log('Public URL:', buildConfig.PUBLIC_URL);
export const gitInfo = {
    branch: `${buildConfig.gitInfo.branch || 'unknown'}`,
    commit: `${buildConfig.gitInfo.abbreviatedSha || buildConfig.gitInfo.sha || 'unknown'}`
};
export const GitTag = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        id: "buildInfo",
        style: {
            display: 'none'
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    "Branch: ",
                    gitInfo.branch
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    "Tag: ",
                    gitInfo.commit
                ]
            })
        ]
    });
};
